import React, { useEffect, useState } from "react";
import Header from "./Header/Header";
import Information from "./Information/Information";
import Chart from "./Chart/Chart";
import RowMaterial from "./RowMaterialInfo/RowMaterial";
import { CommonAPImain } from "../../../Utils/API/CommonAPImain/CommonAPImain";
import { CircularProgress } from "@mui/material";
import { useSetRecoilState } from "recoil";
import {
  homeChartData,
  homeFgStockData,
  homeOrderData,
  homeoutrStandData,
  homeRawMaterialData,
  homeSaleData,
} from "../../Recoil/atom";

const Home = () => {
  const [isLoading, setIsLoading] = useState(true);
  const setHomeSaleData = useSetRecoilState(homeSaleData);
  const setHomeOrderData = useSetRecoilState(homeOrderData);
  const setHomeOuterSatndData = useSetRecoilState(homeoutrStandData);
  const setHomeFgstockData = useSetRecoilState(homeFgStockData);
  const setHomeChartData = useSetRecoilState(homeChartData);
  const setHomeRawMaterialData = useSetRecoilState(homeRawMaterialData);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const saleData = CommonAPImain("Home_Sale");
      const orderData = CommonAPImain("Home_Order");
      const outStandingData = CommonAPImain("Home_Outstanding");
      const fgStockData = CommonAPImain("Home_FgStock");
      const purchaseSaleChart = CommonAPImain("Home_PurchaseSaleChart");
      const productionData = CommonAPImain("Home_Production");
      const UserDetail = CommonAPImain("UserDetail");

      const responses = await Promise.all([
        saleData,
        orderData,
        outStandingData,
        fgStockData,
        purchaseSaleChart,
        productionData,
        UserDetail
      ]);

      if (responses[0]?.Status == 200) {
        setIsLoading(false);
        setHomeSaleData(responses[0]?.Data?.DT[0]);
        sessionStorage.setItem(
          "saleData",
          JSON.stringify(responses[0]?.Data?.DT[0])
        );
      }
      if (responses[1]?.Status == 200) {
        setIsLoading(false);
        setHomeOrderData(responses[1]?.Data?.DT[0]);
        sessionStorage.setItem(
          "orderData",
          JSON.stringify(responses[1]?.Data?.DT[0])
        );
      }
      if (responses[2]?.Status == 200) {
        setIsLoading(false);
        setHomeOuterSatndData(responses[2]?.Data?.DT[0]);
        sessionStorage.setItem(
          "outStandingData",
          JSON.stringify(responses[2]?.Data?.DT[0])
        );
      }
      if (responses[3]?.Status == 200) {
        setIsLoading(false);
        setHomeFgstockData(responses[3]?.Data?.DT[0]);
        sessionStorage.setItem(
          "fgStockData",
          JSON.stringify(responses[3]?.Data?.DT[0])
        );
      }
      if (responses[4]?.Status == 200) {
        setIsLoading(false);
        setHomeChartData(responses[4]?.Data?.DT[0]);
        sessionStorage.setItem(
          "PurchaseSaleChart",
          JSON.stringify(responses[4]?.Data)
        );
      }
      if (responses[5]?.Status == 200) {
        setIsLoading(false);
        setHomeRawMaterialData(responses[5]?.Data?.DT[0]);
        sessionStorage.setItem(
          "Production",
          JSON.stringify(responses[5]?.Data?.DT[0])
        );
      }

      if (responses[6]?.Status == 200) {
        const profileData = responses[6]?.Data?.DT[0];
        sessionStorage.setItem("profileData", JSON.stringify(profileData));
      }
      
      setIsLoading(false);
    } catch (err) {
      console.log(err);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const storedSaleData = sessionStorage.getItem("saleData");
    const storedOrderData = sessionStorage.getItem("orderData");
    const storedOutStandingData = sessionStorage.getItem("outStandingData");
    const storedFgStockData = sessionStorage.getItem("fgStockData");
    const storedCart = sessionStorage.getItem("PurchaseSaleChart");
    const Production = sessionStorage.getItem("Production");
    if (
      storedSaleData ||
      storedOrderData ||
      storedOutStandingData ||
      storedFgStockData ||
      storedCart ||
      Production
    ) {
      setIsLoading(false);
    } else {
      fetchData();
    }

    const intervalId = setInterval(() => {
      fetchData();
    }, 3600000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  const handleRefresh = () => {
    sessionStorage.removeItem("saleData");
    sessionStorage.removeItem("orderData");
    sessionStorage.removeItem("outStandingData");
    sessionStorage.removeItem("fgStockData");
    sessionStorage.clear();
    fetchData();
  };

  return (
    <div style={{ paddingBottom: "60px" }}>
      {isLoading ? (
        <div className="loader-overlay">
          <CircularProgress className="loadingBarManage" />
        </div>
      ) : (
        <>
          <Header handleRefresh={handleRefresh} />
          <Information />
          <Chart />
          <RowMaterial />
        </>
      )}
    </div>
  );
};

export default Home;
























// import React, { useEffect, useState } from "react";
// import Header from "./Header/Header";
// import Information from "./Information/Information";
// import Chart from "./Chart/Chart";
// import RowMaterial from "./RowMaterialInfo/RowMaterial";
// import { CommonAPImain } from "../../../Utils/API/CommonAPImain/CommonAPImain";
// import { CircularProgress } from "@mui/material";
// import { useSetRecoilState } from "recoil";
// import {
//   homeChartData,
//   homeFgStockData,
//   homeOrderData,
//   homeoutrStandData,
//   homeRawMaterialData,
//   homeSaleData,
// } from "../../Recoil/atom";

// const Home = () => {
//   const [isLoading, setIsLoading] = useState(true);
//   const setHomeSaleData = useSetRecoilState(homeSaleData);
//   const setHomeOrderData = useSetRecoilState(homeOrderData);
//   const setHomeOuterSatndData = useSetRecoilState(homeoutrStandData);
//   const setHomeFgstockData = useSetRecoilState(homeFgStockData);
//   const setHomeChartData = useSetRecoilState(homeChartData);
//   const setHomeRawMaterialData = useSetRecoilState(homeRawMaterialData);

//   const fetchData = async () => {
//     setIsLoading(true);
//     try {
//       const saleData = CommonAPImain("Home_Sale");
//       const orderData = CommonAPImain("Home_Order");
//       const outStandingData = CommonAPImain("Home_Outstanding");
//       const fgStockData = CommonAPImain("Home_FgStock");
//       const purchaseSaleChart = CommonAPImain("Home_PurchaseSaleChart");
//       const productionData = CommonAPImain("Home_Production");

//       const responses = await Promise.all([
//         saleData,
//         orderData,
//         outStandingData,
//         fgStockData,
//         purchaseSaleChart,
//         productionData,
//       ]);

//       if (responses[0]?.Status == 200) {
//         setIsLoading(false);
//         setHomeSaleData(responses[0]?.Data?.DT[0]);
//         sessionStorage.setItem(
//           "saleData",
//           JSON.stringify(responses[0]?.Data?.DT[0])
//         );
//       }
//       if (responses[1]?.Status == 200) {
//         setIsLoading(false);
//         setHomeOrderData(responses[1]?.Data?.DT[0]);
//         sessionStorage.setItem(
//           "orderData",
//           JSON.stringify(responses[1]?.Data?.DT[0])
//         );
//       }
//       if (responses[2]?.Status == 200) {
//         setIsLoading(false);
//         setHomeOuterSatndData(responses[2]?.Data?.DT[0]);
//         sessionStorage.setItem(
//           "outStandingData",
//           JSON.stringify(responses[2]?.Data?.DT[0])
//         );
//       }
//       if (responses[3]?.Status == 200) {
//         setIsLoading(false);
//         setHomeFgstockData(responses[3]?.Data?.DT[0]);
//         sessionStorage.setItem(
//           "fgStockData",
//           JSON.stringify(responses[3]?.Data?.DT[0])
//         );
//       }
//       if (responses[4]?.Status == 200) {
//         setIsLoading(false);
//         setHomeChartData(responses[4]?.Data?.DT[0]);
//         sessionStorage.setItem(
//           "PurchaseSaleChart",
//           JSON.stringify(responses[4]?.Data)
//         );
//       }
//       if (responses[5]?.Status == 200) {
//         setIsLoading(false);
//         setHomeRawMaterialData(responses[5]?.Data?.DT[0]);
//         sessionStorage.setItem(
//           "Production",
//           JSON.stringify(responses[5]?.Data?.DT[0])
//         );
//       }
//       setIsLoading(false);
//     } catch (err) {
//       console.log(err);
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     const storedSaleData = sessionStorage.getItem("saleData");
//     const storedOrderData = sessionStorage.getItem("orderData");
//     const storedOutStandingData = sessionStorage.getItem("outStandingData");
//     const storedFgStockData = sessionStorage.getItem("fgStockData");
//     const storedCart = sessionStorage.getItem("PurchaseSaleChart");
//     const Production = sessionStorage.getItem("Production");
//     if (
//       storedSaleData ||
//       storedOrderData ||
//       storedOutStandingData ||
//       storedFgStockData ||
//       storedCart ||
//       Production
//     ) {
//       setIsLoading(false);
//     } else {
//       fetchData();
//     }

//     const intervalId = setInterval(() => {
//       fetchData();
//     }, 3600000);

//     return () => {
//       clearInterval(intervalId);
//     };
//   }, []);

//   const handleRefresh = () => {
//     sessionStorage.removeItem("saleData");
//     sessionStorage.removeItem("orderData");
//     sessionStorage.removeItem("outStandingData");
//     sessionStorage.removeItem("fgStockData");
//     sessionStorage.clear();
//     fetchData();
//   };

//   return (
//     <div style={{ paddingBottom: "60px" }}>
//       {isLoading ? (
//         <div className="loader-overlay">
//           <CircularProgress className="loadingBarManage" />
//         </div>
//       ) : (
//         <>
//           <Header handleRefresh={handleRefresh} />
//           <Information />
//           <Chart />
//           <RowMaterial />
//         </>
//       )}
//     </div>
//   );
// };

// export default Home;



























// import React, { useEffect, useState } from "react";
// import Header from "./Header/Header";
// import Information from "./Information/Information";
// import Chart from "./Chart/Chart";
// import RowMaterial from "./RowMaterialInfo/RowMaterial";
// import { CommonAPImain } from "../../../Utils/API/CommonAPImain/CommonAPImain";
// import { CircularProgress } from "@mui/material";

// const Home = () => {
//   const [isLoading, setIsLoading] = useState(true);
//   const [completedCount, setCompletedCount] = useState(0);

//   const fetchData = async () => {
//     try {
//       const apiEndpoints = [
//         { key: "saleData", endpoint: "Home_Sale" },
//         { key: "orderData", endpoint: "Home_Order" },
//         { key: "outStandingData", endpoint: "Home_Outstanding" },
//         { key: "fgStockData", endpoint: "Home_FgStock" },
//         { key: "PurchaseSaleChart", endpoint: "Home_PurchaseSaleChart" },
//         { key: "Production", endpoint: "Home_Production" },
//       ];

//       for (const { key, endpoint } of apiEndpoints) {
//         const response = await CommonAPImain(endpoint); // Sequential call
//         if (response?.Status === "200") {
//           const dataToStore = response?.Data?.DT?.[0] || response?.Data; // Handle missing DT or DT[0]
//           if (dataToStore) {
//             sessionStorage.setItem(key, JSON.stringify(dataToStore));
//           }
//         } else {
//           console.error(`Error in API call ${endpoint}:`, response);
//         }
//         setCompletedCount((prevCount) => prevCount + 1);
//       }

//       setIsLoading(false); // Mark loading as complete after all API calls
//     } catch (err) {
//       console.error("Error fetching data:", err);
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     const storedSaleData = sessionStorage.getItem("saleData");
//     const storedOrderData = sessionStorage.getItem("orderData");
//     const storedOutStandingData = sessionStorage.getItem("outStandingData");
//     const storedFgStockData = sessionStorage.getItem("fgStockData");
//     const storedCart = sessionStorage.getItem("PurchaseSaleChart");
//     const Production = sessionStorage.getItem("Production");

//     console.log("Stored Data on Load:", {
//       storedSaleData,
//       storedOrderData,
//       storedOutStandingData,
//       storedFgStockData,
//       storedCart,
//       Production,
//     });

//     if (
//       storedSaleData ||
//       storedOrderData ||
//       storedOutStandingData ||
//       storedFgStockData ||
//       storedCart ||
//       Production
//     ) {
//       setIsLoading(false);
//     } else {
//       fetchData();
//     }

//     const intervalId = setInterval(() => {
//       fetchData();
//     }, 3600000);

//     return () => {
//       clearInterval(intervalId);
//     };
//   }, []);

//   const handleRefresh = () => {
//     sessionStorage.clear(); // Clear all stored data
//     setCompletedCount(0); // Reset count
//     fetchData(); // Fetch data again
//   };

//   return (
//     <div style={{ paddingBottom: "60px" }}>
//       {isLoading ? (
//         <div className="loader-overlay">
//           <CircularProgress className="loadingBarManage" />
//           <div>API calls completed: {completedCount}/6</div>
//         </div>
//       ) : (
//         <>
//           <Header handleRefresh={handleRefresh} />
//           <Information />
//           <Chart />
//           <RowMaterial />
//           <div style={{ marginTop: "20px", textAlign: "center" }}>
//             API calls completed: {completedCount}
//           </div>
//         </>
//       )}
//     </div>
//   );
// };

// export default Home;
